import { ApolloClient, HttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import apolloLogger from 'apollo-link-logger';;
import createCache from './createCache';

const link = from([
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) => 
      console.warn(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
      );
    if (networkError) console.warn(`[Network error]: ${networkError}`);
  }),
  // ...(__DEV__ ? [apolloLogger] : []),
new HttpLink({
  uri: '/graphql',
  credentials: 'include',
}),
]);

const cache = createCache();

export default function createApolloClient() {
  return new ApolloClient({
    link,
    cache: cache.restore(window.APP_STATE),
    queryDeduplication: true,
    connectToDevTools: true,
  });
}